import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { labOrderService } from '../../lib/services.lab';

const OrderDetails: React.FC = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrder();
  }, [orderId]);

  const loadOrder = async () => {
    if (!orderId) {
      navigate('/lab');
      return;
    }

    try {
      const order = await labOrderService.getById(orderId);
      
      if (!order) {
        navigate('/lab');
        return;
      }

      switch (order.status) {
        case 'ordered':
        case 'collected':
          navigate(`/lab/orders/${orderId}/results`, { replace: true });
          break;
        case 'in_progress':
        case 'verified':
          navigate(`/lab/orders/${orderId}/verify`, { replace: true });
          break;
        case 'finalized':
          navigate(`/lab/orders/${orderId}/report`, { replace: true });
          break;
        default:
          navigate('/lab');
      }
    } catch (error) {
      console.error('Error loading order:', error);
      navigate('/lab');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return null;
};

export default OrderDetails;
